/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-consents" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-consents" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-consents" */ `./edit.vue` );
const Settings = () => import( /* webpackChunkName: "group-consents" */ `./settings.vue` );

export default {
	path: `consents`,
	children: [
		{
			path: ``,
			name: `list-consents`,
			component: List,
			meta: {
				title: `Consents`
			}
		},
		{
			path: `settings`,
			name: `consent-settings`,
			component: Settings,
			meta: {
				title: `Consent Settings`
			}
		},
		{
			path: `new`,
			name: `add-consent`,
			component: Add,
			meta: {
				title: `Add Consent`
			}
		},
		{
			path: `:uuid`,
			name: `edit-consent`,
			component: Edit,
			meta: {
				title: `Edit Consent`
			}
		}
	]
};
